import React, { Component } from 'react'

export default class WorksTerraScotta extends Component {
  render() {
    return (
 <div class="modal" id="worksterrascotta" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-full" role="document">
        <div class="modal-content">
          <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
            <div class="modal-header">
                <h5 class="modal-title"><strong>&quot;QUANDO LA TERRA SCOTTA. Vita di un giovane africano dal Mali al Trentino&quot; </strong>(biografia): <em>Ediz. PeQuod 2019, pag 245, euro 18 <br /> distribuz. Messaggerie, cod. 0978886068150.</em></h5>
            </div>
            <div class="modal-body p-4" id="result">
                   

            <div align="left">

<table border="0"  cellpadding="20">
  <tr colspan="1" width="100%">
  </tr>
  <tr width="100%">

    <td width="50%">


<br/> <br/>

        
<div className="desc">
										<p>Soma Makan Fofana è un giovane approdato da clandestino sulle coste italiane, che qualche anno più tardi ha voluto raccontare per intero la propria esistenza. L'infanzia vissuta fra poverissimi villaggi del Mali e segnata da una serie di laceranti abbandoni. L'adolescenza che lo vede vagare per le strade della capitale Bamako, solo e affamato, straniero nel proprio Paese e spinto a compiere azioni che ancora oggi non riesce a perdonarsi. La scelta di cercare altrove una vita migliore, costretto però a subire le violenze e gli abusi dei trafficanti di uomini che presidiano i confini e l'infernale traversata del deserto. Il lungo periodo trascorso in Libia, dove dopo altre vicissitudini riesce a trovare una buona occupazione e una speranza per il futuro, finché lo scoppio della guerra civile che travolgerà Gheddafi lo priva nuovamente di tutto, gli lascia il mare come unica via di fuga. Ed ecco quindi il barcone degli scafisti, l’approdo a Lampedusa e la successiva destinazione in un Centro di accoglienza del Trentino. Per Soma è la svolta decisiva, con un lavoro che gli consente di dare aiuto ad altri giovani profughi, con una donna, una casa e la nascita di un figlio. Poi arriva l'incontro con lo scrittore insieme al quale decide di scrivere questo libro.  </p>
										<p>Ha preso forma così quella che si presenta come un'esemplare vicenda di epica contemporanea, in cui fra continui colpi di scena si alternano sentimenti universali e sconvolgenti episodi, scenari di guerra e toccanti esperienze di amicizia e di amore, sullo sfondo di una delle più gravi emergenze del nostro tempo e di quello a venire.</p>


										<p>Soma Makan Fofana è nato in un villaggio nel sud del Mali una trentina di anni fa, non potrà mai sapere in che data precisa. Dopo le innumerevoli traversie di cui dà conto questo libro, nel 2011 è riuscito a raggiungere le coste italiane da immigrato clandestino. Di lì a poco è approdato in Trentino, dove dopo aver svolto varie attività oggi lavora come mediatore culturale in progetti di accoglienza.</p>

									</div>
      
   



<br/>

<strong>ne hanno scritto:</strong> <br/><br/>
<ul>
<li>Roberto Carnero, Famiglia cristiana, 13/2020</li>
<li><a href="rec/quandolaterrascotta/Rassegna stampa 1.pdf" target="_blank" >Claudio Toscani, Avvenire, 7/12/2019</a></li>
<li><a href="rec/quandolaterrascotta/Rassegna stampa 3.pdf" target="_blank" >Fabrizio Franchi, l’Adige, 3/11/2019</a></li>
<li><a href="rec/quandolaterrascotta/Rassegna stampa 2.pdf" target="_blank" >Fausta Slanzi e Mario Cossali, Trentino, 7/11/2019</a></li>
<li>N. T., Il Tirreno e La Nazione, 14/12/2019</li>
<li>Cla.Ro., Il corriere di Romagna, 22/11/2019</li>

<li>Intervista a “Fahrenheit”, RAI Radio 3, 3/12/2019</li>
</ul>

</td >


</tr>
<tr>
<img src="images/foto/foto_alex_soma_med.jpg" className="img-responsive" alt="book cover" />


</tr>
</table>
</div>















            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
        </div>
    </div>
</div>


    )
  }
}
